import { render } from "./ChatAssistant.vue?vue&type=template&id=28a7e77a&scoped=true"
import script from "./ChatAssistant.js?vue&type=script&lang=js&external"
export * from "./ChatAssistant.js?vue&type=script&lang=js&external"

import "./ChatAssistant.vue?vue&type=style&index=0&id=28a7e77a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a7e77a"],['__file',"src/Components/ChatWidget/ChatAssistant/ChatAssistant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28a7e77a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28a7e77a', __exports__)) {
    api.reload('28a7e77a', __exports__)
  }
  
  module.hot.accept("./ChatAssistant.vue?vue&type=template&id=28a7e77a&scoped=true", () => {
    api.rerender('28a7e77a', render)
  })

}


export default __exports__